import Editor from '@monaco-editor/react';
import { languageForPath } from './MonacoDocumentEditor';
import { useKnowledgeBuilderColors } from '../../theme/knowledgeBuilderColors';

export const CodeDocumentPreview = ({
  path,
  content,
}: {
  path: string;
  content: string;
}) => {
  const colors = useKnowledgeBuilderColors();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        minWidth: 0,
        minHeight: 0,
        overflow: 'hidden',
        background: colors.bg.panel,
      }}
    >
      <Editor
        value={content}
        language={languageForPath(path)}
        theme={colors.monacoTheme}
        options={{
          readOnly: true,
          minimap: {
            enabled: true,
            scale: 1,
            showSlider: 'mouseover',
          },
          wordWrap: 'on',
          scrollBeyondLastLine: false,
          fontSize: 13,
          fontFamily:
            '"SF Mono", Menlo, Monaco, Consolas, "Liberation Mono", monospace',
          lineHeight: 20,
          automaticLayout: true,
          bracketPairColorization: {
            enabled: true,
          },
          contextmenu: false,
          folding: true,
          glyphMargin: false,
          lineNumbersMinChars: 4,
          padding: {
            top: 12,
            bottom: 12,
          },
          renderLineHighlight: 'none',
          roundedSelection: false,
          scrollbar: {
            verticalScrollbarSize: 12,
            horizontalScrollbarSize: 12,
          },
          smoothScrolling: true,
          stickyScroll: {
            enabled: true,
          },
        }}
      />
    </div>
  );
};